import { Injectable } from '@angular/core';
import {  UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CreateInvoiceFormRequest } from '@invoice-upload/models/create-invoice-form-request';
import { Creditor } from '@feature/creditor-accounts/models/creditor-account-model';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDocumentFormService {

  constructor(
    private readonly formBuilder: UntypedFormBuilder) { }

  getForm(): UntypedFormGroup {

    const form = this.formBuilder.group({
      accountFor: [null, []],
      documentType: [null, [Validators.required]],
      documentDate: [new Date(), [Validators.required]],
      documentReference: [null, [Validators.required, Validators.maxLength(35)]],
      purchaseOrderOrContractId: [null, []],
      fromDate: [new Date(), []],
      toDate: [new Date(), []],

      netAmount: [null, [Validators.required]],
      vatRate: [null, [Validators.required]],
      vatAmount: [null, [Validators.required]],
      grossAmount: [null],

      billingAddress: [null, [Validators.maxLength(320)]],
      servicesRendered: [null, [Validators.maxLength(40), Validators.required]],
    });

    return form;

  }

  formToModel(form: UntypedFormGroup,
    getAccounts: () => Creditor[]): CreateInvoiceFormRequest {

    const request = new CreateInvoiceFormRequest();

    const accounts = getAccounts();
    const defaultAccount = accounts ? accounts[0].Uri : null;
    if (accounts.length === 1) {
      request.CreditorUri = accounts[0].Uri;
    } else {
      request.CreditorUri = form.get('accountFor').value.Uri || defaultAccount;
    }
    request.DocumentTypeCode = form.get('documentType').value;
    request.DocumentDate = form.get('documentDate').value;
    request.DocumentReference = form.get('documentReference').value;
    request.NetAmount = form.get('netAmount').value;
    request.VatRateCode = form.get('vatRate').value.Code;
    request.VatAmount = form.get('vatAmount').value;
    request.GrossAmount = form.get('grossAmount').value;
    request.BillingAddress = form.get('billingAddress').value;
    request.ServicesRendered = form.get('servicesRendered').value;
    request.FromDate = form.get('fromDate').value;
    request.ToDate = form.get('toDate').value;
    if(request.FromDate == null || request.ToDate == null){
      request.PurchaseOrderId = form.get('purchaseOrderOrContractId').value?.Value;
    }else{
      request.ContractId = form.get('purchaseOrderOrContractId').value?.Value;
    }
    return request;
  }
}
